<template>
    <div class="ReturnOrderHistory row" style="min-width: 1200px; min-height: 100%; overflow: auto;">
        <q-dialog position="right" v-model="orderDetailDialog">
            <ReturnOrderDetail :order-id="orderId" @closeDialog="orderDetailDialog=false"></ReturnOrderDetail>
        </q-dialog>
        <div class="card q-pa-md">
            <div class="row">
                <div class="d-flex col-12 q-pa-md pt-0"
                     style="justify-content: space-between; align-items: center ">
                    <div class="app-fixed-header"
                         style="width: 1200px; left: unset; top: 25px !important; right: 0px !important;">
                        <div class="d-flex justify-content-between w-100" style="align-items: center; height: 60px;">
                            <h4 style="font-size: 26px; font-weight: 300; margin-left: 25px; ">
                                Return Order History </h4>
                            <div class="d-flex" style="justify-content: space-between">
                                <q-btn @click="closeDialog" class="float-right" color="primary" dense flat icon="close">
                                    <q-tooltip>Close</q-tooltip>
                                </q-btn>
                            </div>
                        </div>
                    </div>
                    <q-timeline color="blue-10" style="font-size: 16px !important; margin-top: 50px;">
                        <template v-for="(returnOrder,index) in returnOrderHistory">
                            <q-timeline-entry>
                                <q-card @click="openOrderDetail(returnOrder.Order.id)" class="product-card">
                                    <q-card-section>
                                        <div class="mp-card row">
                                            <div class="col-8">
                                                <div class="mp-header pr-3">
                                                    <div class="d-flex justify-content-between"
                                                         style=" align-items: center">
                                                        <div class="d-flex">
                                                            <div class="text-left">
                                                                <span class="bankLabel ">Order ID</span>
                                                                <h6>
                                                                    {{returnOrder.Order.orderNum?returnOrder.Order.orderNum:'-'}} </h6>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex">
                                                            <q-chip class="custom-chip" color="primary" icon="person"
                                                                    outline text-color="white">
                                                                {{returnOrder.Order&&returnOrder.Order.ToOrganization?returnOrder.Order.ToOrganization.PartnerType.prefix:'-'}}
                                                            </q-chip>
                                                            <q-chip class="custom-chip" color="primary" icon="payment"
                                                                    outline text-color="white">
                                                                {{returnOrder.Order.status?returnOrder.Order.status:'-'}}
                                                            </q-chip>
                                                            <q-chip class="custom-chip" color="primary" outline>
                                                                {{returnOrder.Order.OrderItems_aggregate.aggregate.count}}
                                                                {{returnOrder.Order.OrderItems_aggregate.aggregate.count>1?'Items':'Item'}}
                                                            </q-chip>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr class="my-2 mr-3" style="border: 0.5px solid lightgray">
                                                <div class="mp-body ">
                                                    <div class="row">
                                                        <div class="col-4">
                                                            <div class="text-left">
                                                                <span class="bankLabel text-left">Order From</span>
                                                                <div class="mp-value text-left">
                                                                    <span class="text-left">{{returnOrder.Order&&returnOrder.Order.FromOrganization?returnOrder.Order.FromOrganization.name:'-'}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-4 d-flex" style="align-items: center">
                                                            <div class="text-left">
                                                                <img alt="" src="../../assets/point_line.png"
                                                                     style="width: 50%;">
                                                            </div>
                                                        </div>
                                                        <div class="col-4">
                                                            <div class="text-left">
                                                                <span class="bankLabel text-left">Order To</span>
                                                                <div class="mp-value text-left">
                                                                    <span class="text-left">
                                                                        {{returnOrder.Order&&returnOrder.Order.ToOrganization?returnOrder.Order.ToOrganization.name:'-'}}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-3 mt-3">
                                                            <div class="text-left">
                                                                <span class="bankLabel text-left">Order Date</span>
                                                                <div class="mp-value text-left">
                                                                    <span>{{returnOrder.Order.date?dateFilter(returnOrder.Order.date):'-'}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-3 mt-3">
                                                            <div class="text-left">
                                                                <span class="bankLabel text-left">Invoice Number</span>
                                                                <div class="d-flex ">
                                                                    <div class="mp-value text-left">
                                                                        <span class="text-left">{{returnOrder.Order.invoiceNumber?returnOrder.Order.invoiceNumber:'-'}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-3 mt-3">
                                                            <div class="text-left">
                                                                <span class="bankLabel text-left">Created On</span>
                                                                <div class="mp-value text-left">
                                                                    <span class="text-left">{{returnOrder.Order.createdOn?dateTimeFilter(returnOrder.Order.createdOn):'-'}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-3 mt-3">
                                                            <div class="text-left">
                                                                <span class="bankLabel text-left">Invoice Date</span>
                                                                <div class="d-flex ">
                                                                    <div class="mp-value text-left">
                                                                        <span class="text-left">{{returnOrder.Order.invoiceDate?dateFilter(returnOrder.Order.invoiceDate):'-'}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <ul>
                                                        <div class="" style="align-items: center">
                                                            <ul class="d-flex"></ul>
                                                        </div>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-4 q-pa-md" style="border-left: 1px solid lightgrey;">
                                                <div class="text-left mp-value d-flex justify-content-between mb-3">
                                                    <span style="color: #000;">Return Order Points</span>
                                                    <h6 style="color: #191919;">
                                                        {{returnOrder.returnOrderPoint?returnOrder.returnOrderPoint:'-'}}
                                                    </h6>
                                                </div>
                                                <div class="text-left mp-value d-flex justify-content-between my-3">
                                                    <span style="color: #000;">Return Booster Points</span>
                                                    <h6 style="color: #191919;">
                                                        {{returnOrder.returnOrderBoosterPoint?returnOrder.returnOrderBoosterPoint:'-'}}
                                                    </h6>
                                                </div>
                                                <hr class="my-2" style="border: 0.5px dashed lightgray">
                                                <div class="text-left mp-value d-flex justify-content-between my-3">
                                                    <span class="bankLabel">Total Return Points</span>
                                                    <h4 style="font-size: 22px; line-height: 1.5rem; font-weight: 300; ">
                                                        {{returnOrder.returnOrderPoint+returnOrder.returnOrderBoosterPoint}}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </q-card-section>
                                </q-card>
                            </q-timeline-entry>
                        </template>
                    </q-timeline>
                </div>
            </div>
            <div class="text-center" v-if="!returnOrderHistory.length">
                <div class="d-block mx-auto w-50">
                    <img alt="" class="w-100 d-block mx-auto" src="../../assets/no_Data.png">
                </div>
                <h6>No Return Order history available</h6>
            </div>
        </div>
    </div>
</template>

<script>
  import { GET_RETURN_ORDER_HISTORY } from '../../graphql/queries/ReturnOrder'
  import ReturnOrderDetail from './ReturnOrderDetail'

  export default {
    name: 'ReturnOrderHistory',
    components: { ReturnOrderDetail },
    props: ['schemeId', 'partnerId'],
    data () {
      return {
        returnOrderHistory: [],
        orderDetailDialog: false,
        orderId: null,
      }
    },
    apollo: {
      ReturnOrderHistory: {
        query: GET_RETURN_ORDER_HISTORY,
        fetchPolicy:'network-only',
        skip () {return !(this.schemeId && this.partnerId)},
        variables () {
          return {
            partnerId: this.partnerId,
            schemeId: this.schemeId,
          }
        },
        result ({ data, loading }) {
          if (!loading) {
            this.returnOrderHistory = data.ReturnOrderHistory
          }
        },
      },
    },
    methods: {
      openOrderDetail (orderId) {
        this.orderId = orderId
        this.orderDetailDialog = true
      },
      closeDialog () {
        this.$emit('closeDialog', false)
      },
    },
  }
</script>

<style scoped>
    .card {
        width: 100%;
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: bottom;
        border-radius: 4px;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
        position: relative;
    }
</style>
